module.exports = __webpack_public_path__ + "img/blockchainlogo.40d1037e.png";